export default __webpack_public_path__ + "static/media/50d.21df920a.svg";